<template>
    <div class="card flex-md-row">
        <div class="card-body d-flex flex-column align-items-start p-2">
            <div class="d-flex flex-row align-items-center justify-content-between flex-nowrap w-100  mb-1">
                <strong class="d-inline-block text-info">
                    {{ title }}
                </strong>
                <span class="badge" :class="classServiceCode">
                    {{ serviceCode }}
                </span>
            </div>
            <p class="card-text text-left small mb-1" v-if="abstract">
                {{ abstract }}
            </p>
            <div class="row w-100">
                <div class="col-12 col-sm-auto" v-if="name">
                    <p class="card-text small d-flex flex-nowrap align-items-center mb-0 mt-1">
                        <i class="fas fa-layer-group mr-2"></i> <span>{{ name }}</span>
                    </p>
                </div>
                <div class="col-12 col-sm-auto" v-if="serviceName">
                    <p class="card-text small d-flex flex-nowrap align-items-center mb-0 mt-1">
                        <i class="fas fa-earth-americas mr-2"></i> <span>{{ serviceName }}</span>
                    </p>
                </div>
            </div>
            <div class="text-right w-100 mt-2" v-if="!readonlyForm">
                <a
                    v-if="!isCrossResource"
                    class="card-link"
                    href="#"
                    @click.prevent="addResource">
                    {{ $t(`global.resources.list.actions.select`) }}
                </a>
                <a
                    v-if="enableAddCrossResource"
                    class="text-nowrap card-link"
                    :class="colorServiceCode"
                    href="#"
                    @click.prevent="addCrossResource">
                    {{ $t(`global.resources.list.actions.add_cross`) }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import OgcMixin from '../mixins/OgcMixin';

export default {
    name: 'ResourceItemList',
    mixins: [
        OgcMixin
    ],
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        readonlyForm: {
            type: Boolean,
            default: true,
        },
        enableCrossResource: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            item: this.value,
        }
    },
    mounted() {
    },
    computed: {
        service() {
            return this.item?.service;
        },
        serviceName() {
            return this.service?.title;
        },
        serviceCode() {
            return this.getServiceCode(this.service)
        },
        classServiceCode() {
            return this.getClassServiceCode(this.service)
        },
        colorServiceCode() {
            return this.getColorServiceCode(this.service)
        },
        title() {
            return this.item?.title;
        },
        name() {
            return this.item?.name ?? this.item?.layers;
        },
        abstract() {
            return this.item?.abstract;// ?? this.$t('global.resources.list.model.no_abstract');
        },
        isCrossResource() {
            return this.serviceCode?.toUpperCase() === 'WFS';
        },
        enableAddCrossResource() {
            return this.enableCrossResource && this.isCrossResource;
        },
    },
    methods: {
        addResource() {
            if(this.readonlyForm){
                return;
            }
            this.$emit('addResource');
        },
        addCrossResource() {
            if(this.readonlyForm){
                return;
            }
            this.$emit('addCrossResource');
        },
    }
}
</script>